<section class="healthcare-banner instool aashi">
    <div class="container">
        <div class="row zmc">
            <div class="col-lg-9 col-md-9 col-sm-12 col-12 service-heading">
                <div class="headtext">
                    <h1>Redefining the social media world with Threndx app’s unique features </h1><br>
                    <title>Threndx Case Study - Fashion E-Commerce Web Development | Vidhema</title>

                    <!-- <p >We design and build superior digital products, delegating seamless user experiences across all modern platforms and devices and helping brands to expand their business globally. -->
                    <!-- </p><a  routerLink="/getaquote.html"
                                            class="ar_contect-industries-header"><span
                                                    >Request a Free
                                                    Quote</span></a> -->
                </div>
            </div>
        </div>
    </div>

</section>
<div class="casestudy-details pt-120 pb-120">
    <div class="container logo-box">
        <img class="threndx-logo" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Untitled-3%20(1).png?alt=media&token=c4aff4a7-7208-462a-918b-ab208d150bce">
    </div>
    <div class="container">
        <div class="row gy-5">
            <div class="col-lg-8">
                <div class="case-details-single">
                    <h2>Threndx
                    </h2>
                    <p class="para mb-30">Threndx is a social media platform application with the aim of connecting
                        friends and family from around every corner of the world.
                    </p>
                    <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Find-the-perfect-car-for-rent-(1).jpg?alt=media&token=2508b3b9-1f4f-44ea-87c6-34d7eae397d1" alt="image"
                        class="img-fluid">
                </div>
            </div>
            <div class="col-lg-4">
                <div class="case-sidebar-area">
                    <ul class="case-info-list">
                        <li>
                            <span>
                                <img src="../../../assets/images/sidebar-arrow.svg" alt="image">Team Size :
                            </span>
                            <h5>
                                16 Members
                            </h5>
                            <h5>
                                Project Manager | Business Analyst | Tech Lead | Developers | Designers | Quality
                                Analyst</h5>
                        </li>
                        <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Industry :</span>
                            <h5>Social Media Platform</h5>
                        </li>
                        <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Duration :</span>
                            <h5> 3 Years</h5>
                        </li>
                        <!-- <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Team:</span>
                           
                        </li> -->
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="case-details-single">
                
                    <div class="area">
                        <h4>Who is the client?</h4>
                        <p class="para">The client is a serial entrepreneur who wants to have a social media
                            application in
                            this online world. He wants to build his business by having a social media application
                            platform
                            of his own. </p>
                    </div>
                    <div class="area">
                        <h4>Purpose of the Client
                        </h4>

                        <p class="para">The client was looking to have a social media platform where he could let
                            people
                            connect with their families and friends. He came up with the idea of having a platform
                            where he
                            could make people connect from around the world making it more unique by adding a few
                            extra
                            features to the application. He has made sure to have an engaging and user-friendly
                            application
                            for the users. </p>
                            <div class="list-title    list-space"><img class="img-value"
                                src="../../../assets/images/list-arrow.svg" alt="image">
                            <p class="para">
                                Users can get to connect with their family and friends and interact with them via this
                                application.
                            </p>
                        </div>
                        <div class="list-title   list-space"><img class="img-value"
                                src="../../../assets/images/list-arrow.svg" alt="image">
                            <p class="para">
                                The users can earn some monetary rewards by writing personalized blogs and posting them on
                                their feeds.
    
                            </p>
                        </div>
                        <div class="list-title   list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">
                            If any user wishes to record audio while using the app, they can do so and then post it to
                            their feed to receive the feedback and reactions of other users around the globe.

                        </p>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="full-area-bg">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-md-8">
                    <div class="case-details-single">
                        <div class="area">
                            <h4>Challenge
                            </h4>
                            <p class="para">The project was new to the world of social media apps. Most importantly, it was very
                                difficult to have an application of this nature to bring it out in the competitive world. The
                                main task is to drive towards the Threndx app in this online world. It is therefore a
                                challenging task to make this app more interesting by implementing some of its unique functions.
                                There are many apps available online that are in a fast phase of development and receive more
                                users every day. This app was created to make it easy for people to connect with loved ones
                                around the globe.
                               <p> Driving users towards the Threndx application in this competitive online world is the main task
                                to perform. Therefore, making this app more engaging by implementing some of its unique features
                                to it is a great task to fulfill. Furthermore, many other apps are present in this online world
                                that is working at a rapid phase and have more visitors on a daily basis. With the help of this
                                app, people should connect easily and hassle-freely with their loved ones from every corner of
                                the world is the main purpose to build this app. The other challenges faced by the client are:</p>
                         
                            <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                <p class="para">
                                    There were no apt features included in the app to engage users.
        
        
                                </p>
                            </div>
                            <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                <p class="para">
        
        
                                    The users were not getting enough analyzed data to fetch the details of the concerned
                                    person.
        
                                </p>
                            </div>
        
                        </div>
                        
                    </div>
                </div>
                <div class="col-xs-12 col-md-4">
                    <img src="assets/images/c-intro.svg" alt="Intro">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="case-details-single">
                    <div class="area">
                        <h4>Solution:</h4>
                    <p class="para">The client reached out to Vidhema Technologies for its mobile app development team
                        with a request to create an app for social media with more intuitive, user-friendly, and unique
                        features which are simply absent in other apps that are already available in the market. The
                        client was looking for a trusted and proven strategic IT solution provider company with
                        expertise in the mobile app development domain to execute his concept into a viable product.
                    </p>
                    <p class="para">
                        As expected by the client, the app developers at Vidhema Technologies have also worked
                        rigorously to bring together a new set of features such as can record audio, featured posts, and
                        writing personalized blogs, etc. that are simply absent from other popular social media
                        applications. All such features have been added to the Threndx app, leveraging the
                        industry-leading technologies for iPhone and Android app development.
                    </p>
                    <p class="para">
                        To make the Threndx app most suitable for targeted users such as youngsters and older people,
                        Vidhema Technologies mobile development team build the Threndx app right from scratch, combining
                        all useful functions like chatting, voice calling, able to add posts and follow and unfollow the
                        users in a button-based app interface. The app has been designed to work as a connecting world
                        together depending upon the user’s needs.
                    </p>


                    <p class="para">
                        Vidhema Technologies and its team were always available to assist the client of Threndx with his
                        dilemma regarding an app. We promised the client that we would complete the task within the
                        deadline and deliver the project on time. We provided a solution for the client that would make
                        the application work according to his plans. Our solution was worth the effort for our client's
                        app.
                    </p>
                    <div class="list-title list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">
                            AI features are implemented to make it smart in the competitive world of social media apps.
                        </p>
                    </div>
                    <div class="list-title list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">
                            Chatbots were implemented to help the users connect with customer care for assistance if any
                            issue persists.
                        </p>
                    </div>
                    <div class="list-title list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">
                            Users will get notified if some other fake user tries to logging their account in their
                            absence. Also, if someone is in trouble that person can send a notification to other users
                            via this app.
                        </p>
                    </div>
                    <div class="list-title list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">
                            Users can also share their live locations via the Threndx social media app.

                        </p>
                    </div>
                    </div>


                    <section class="quote-box" style="    background-color: #0d052a;">
                        <div class="container">
                          <div class="row">
                            <div class="col-md-9">
                              <h4>Are You Ready To Discuss Your Project With Us?</h4>
                            </div>
                            <div class="col-md-3">
                              <button routerLink="/hire-ionic-developers.html">Hire Our Experts</button>
                            </div>
                          </div>
                        </div>
                    </section>
                




                    <div class="area">
                        <h4>Results</h4>
                    <p class="para">We started the journey of building the application 1 year ago and over that period
                        we have been able to develop great and unique features. Currently, we can add friends, follow
                        users, comment on posts and create posts, chat with friends, and write personalized blogs, add
                        pages, groups, and stories. After having discussions and starting working on the project, we
                        manage to keep the features that are unique and new to the social media world.
                    </p>
                    <div class="list-title list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">
                            Availability of Web Application which includes Admin functionalities and other
                            functionalities for both devices.

                        </p>
                    </div>
                    <div class="list-title list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">
                            The solution has the capability to add all the information that is required to know a
                            person.


                        </p>
                    </div>
                    <div class="list-title list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">
                            Both web-based solutions and mobile-based solutions are used by multiple users who are using
                            the app on multiple devices.


                        </p>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="full-area-bg">
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <img src="../../../assets/images/c-intro.svg">
                </div>
                <div class="col-md-8">
                    <div class="case-details-single">
                        
                    <div class="area">
                        <h4>Benefits</h4>
                    <ul class="process-list half-description">
                        <li>
                            <div class="list-title  list-space"><img src="../../../assets/images/list-arrow.svg"
                                    alt="image">
                                <h5>Over 5000+ downloads</h5>
                            </div>
                        </li>
                        <li>
                            <div class="list-title   list-space"><img src="../../../assets/images/list-arrow.svg"
                                    alt="image">
                                <h5>Effective app for old-aged groups</h5>
                            </div>
                        </li>
                        <li>
                            <div class="list-title  list-space"><img src="../../../assets/images/list-arrow.svg"
                                    alt="image">
                                <h5>Easily notifies people</h5>
                            </div>
                        </li>
                        <li>
                            <div class="list-title   list-space"><img src="../../../assets/images/list-arrow.svg"
                                    alt="image">
                                <h5>Agile processes</h5>
                            </div>
                        </li>
                        <li>
                            <div class="list-title  list-space"><img src="../../../assets/images/list-arrow.svg"
                                    alt="image">
                                <h5>Faster approach to the audience</h5>
                            </div>
                        </li>
                        <li>
                            <div class="list-title   list-space"><img src="../../../assets/images/list-arrow.svg"
                                    alt="image">
                                <h5>Cost reduction</h5>
                            </div>
                        </li>
                    </ul>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    

    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="case-details-single">
                    <div class="area">
                        <h4>Technologies and Tools </h4>
                        <ul class="process-list half-description tech-des">
                            <li>
                                <div class="list-title  list-space"><img
                                        src="../../../assets/images/angular-logo.svg" alt="image"
                                        class="tech-logo">
                                    <!-- <h5>Angular</h5> -->
                                </div>
                            </li>
                            <li>
                                <div class="list-title  list-space"><img
                                        src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/salesforcelogo.png?alt=media&token=5f44e444-3e8c-4ece-a679-44b2e06ea243" alt="image"
                                        class="tech-logo">
                                    <!-- <h5>Ionic</h5> -->
                                </div>
                            </li>
                            <li>
                                <div class="list-title  list-space"><img
                                        src="../../../assets/images/nodejs.svg" alt="image"
                                        class="tech-logo">
                                    <!-- <h5>Node JS</h5> -->
                                </div>
                            </li>
                            <li>
                                <div class="list-title  list-space"><img
                                        src="../../../assets/images/MySQL_textlogo.svg" alt="image"
                                        class="tech-logo">
                                    <!-- <h5>MySQL</h5> -->
                                </div>
                            </li>
                            <li>
                                <div class="list-title  list-space"><img
                                        src="../../../assets/images/MongoDB_Logo.svg" alt="image"
                                        class="tech-logo">
                                    <!-- <h5>MongoDB  </h5> -->
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="area">
                        <h4>App Features / Web Admin Features</h4>
                    <ul class="process-list half-description">
                        <li>
                            <div class="list-title  list-space"><img src="../../../assets/images/list-arrow.svg"
                                    alt="image">
                                <h5>Audio </h5>
                            </div>
                            <p class="para">Users have the option to record the song and upload it to their profile.
                                This will allow them to reach the largest audience possible to share, like, comment, and
                                share their posts. People can give reactions whether they like it or not.
                            </p>
                        </li>
                        <li>
                            <div class="list-title  list-space"><img src="../../../assets/images/list-arrow.svg"
                                    alt="image">
                                <h5>Personalized Blog </h5>
                            </div>
                            <p class="para">Users can write blogs and articles on any topic of their choice. Even they
                                can leverage the monetary rewards if their personalized content performs well on their
                                feed.
                            </p>
                        </li>
                        <li>
                            <div class="list-title  list-space"><img src="../../../assets/images/list-arrow.svg"
                                    alt="image">
                                <h5>Featured Post</h5>
                            </div>
                            <p class="para">Users have the option to pin their favorite post to the top or upload a new
                                image and pin it there. This will become a featured post in their feed.
                            </p>
                        </li>
                        <li>
                            <div class="list-title list-space"><img src="../../../assets/images/list-arrow.svg"
                                    alt="image">
                                <h5>Story View </h5>
                            </div>
                            <p class="para">While viewing the story on other social media applications, users usually
                                have to hold the screen to view the full story, but in this app, there is no need to
                                hold the story from the hand.
                            </p>
                        </li>
                        <li>
                            <div class="list-title  list-space"><img src="../../../assets/images/list-arrow.svg"
                                    alt="image">
                                <h5>Language </h5>
                            </div>
                            <p class="para">The app offers a variety of language options. You can browse or use the app
                                in any language you are familiar with.
                            </p>
                        </li>
                        <!-- <li>
                            <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                                <h5>Critical Alerts </h5>
                            </div>
                            <p class="para">This allows you to notify your family and friends of your current condition and whereabouts.</p>
                        </li> -->
                    </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="case-details-single">
                    <div class="area">
                        <h4>Challenges we faced while developing iLastword website and application:</h4>
                    <ul class="process-list">
                        <li>
                            <div class="list-title  list-space"><img src="../../../assets/images/list-arrow.svg"
                                    alt="image">
                                <p class="para">One of the major challenges we faced while developing iLastword was to
                                    provide the client with points that can be included in the website and app from
                                    scratch according to the information provided to us. </p>
                            </div>
                        </li>
                        <li>
                            <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                                <p class="para">Another biggest challenge with the iLastword is encouraging user
                                    engagement and retention via pushing suitable recommendations considering user
                                    requirements. (Most users were old-aged people)</p>
                            </div>
                        </li>
                        <li>
                            <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                                <p class="para">The development of an iLastword program presents another challenge:
                                    maintaining a high level of performance and integrating a lot of information from
                                    the required details.
                                </p>
                            </div>
                        </li>
                    </ul>

                    <p class="para">When client came to us he only had the thought of creating a website of this
                        nature. The client was not very sure what he wanted in the application. Then we did a
                        rigorous research related to this website and had shared our ideas to include the particular
                        features. Vidhema Technologies developed the mobile app and website with this idea making
                        users want to spend more time on the app. We offered him different features that could be
                        implemented in the app.</p>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</div>
